import { BrowserRouter } from "react-router-dom";
import AllRoutes from "routes/Routes";
import Header from "components/main/Header";
import Footer from "components/main/Footer";
import Mobile from "components/main/Mobile";
import { ScrollToTop } from "react-router-scroll-to-top";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import CartModal from "common/order/CartModal";
import WithAuthenticationContext from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import withClearCache from "hoc/WithClearCache";
import { useState, useEffect } from "react";

const ClearCacheComponent = withClearCache(MainApp);

function MainApp({}) {
  const [backButtonPressed, setBackButtonPressed] = useState(false);
  useEffect(() => {
    window.onpopstate = () => {
      setBackButtonPressed((prev) => !prev);
    };
  }, []);

  const auth = useContext(WithAuthenticationContext);
  return (
    <div className="App">
      <ReactTooltip></ReactTooltip>
      <div>
        <Toaster />
      </div>
      <WithAuthentication>
        <BrowserRouter>
          <ScrollToTop />
          <Header backButtonPressed={backButtonPressed} />

          {auth.userInfo.userType == 1 && <CartModal></CartModal>}

          <AllRoutes></AllRoutes>
          <Footer>
            <Mobile />
          </Footer>
        </BrowserRouter>
      </WithAuthentication>
    </div>
  );
}

function App() {
  return <ClearCacheComponent />;
}

export default App;
